import React from "react";
import { useTranslation } from "react-i18next";
import FloatingLabelInput from "../utils/FloatingLabelInput";
import { validateEmail } from "../../utils/validationUtils";
import linkedInLogo from "../../assets/linkedin_login_logo.svg";
import googleLogo from "../../assets/google_login_logo.svg";
import githubLogo from "../../assets/github_login_logo.svg";
import emailLoginGlyph from "../../assets/email_login.svg";

interface UserLoginViewProps {
  error: string | null;
  email: string;
  onGoogleLogin: () => void;
  onLinkedInLogin: () => void;
  onGithubLogin: () => void;
  onEmailSubmit: (e: React.FormEvent) => void;
  onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const UserLoginView: React.FC<UserLoginViewProps> = ({
  error,
  email,
  onGoogleLogin,
  onLinkedInLogin,
  onGithubLogin,
  onEmailSubmit,
  onEmailChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="login-options">
      <div className="login-title">{t("auth.signInTitle")}</div>

    {error && <div className="login-error-message">{error}</div>}

      {/* Google login */}
      <button className="login-button" onClick={onGoogleLogin}>
        <img src={googleLogo} alt={t("auth.altGoogle")} className="button-icon google-icon" />
        <span>{t("auth.continueWithGoogle")}</span>
      </button>

      {/* LinkedIn login */}
      <button className="login-button" onClick={onLinkedInLogin}>
        <img src={linkedInLogo} alt={t("auth.altLinkedIn")} className="button-icon linkedin-login-icon" />
        <span>{t("auth.continueWithLinkedIn")}</span>
      </button>

      {/* GitHub login */}
      <button className="login-button" onClick={onGithubLogin}>
        <img src={githubLogo} alt={t("auth.altGitHub")} className="button-icon github-login-icon" />
        <span>{t("auth.continueWithGitHub")}</span>
      </button>

      {/* Divider */}
      <div className="login-divider">
        <span>{t("auth.or")}</span>
      </div>

      {/* Email input and submit */}
      <form onSubmit={onEmailSubmit} className="email-login">
        <FloatingLabelInput
          label={t("auth.emailAddress")}
          type="email"
          name="email"
          value={email}
          onChange={onEmailChange}
          required
        />
        <button
          type="submit"
          disabled={!email || !validateEmail(email)}
          // className={"login-button email-button"}
          className={"entryflow-submit-button"}
        >
          <img src={emailLoginGlyph} alt={t("auth.altEmail")} className="button-icon email-icon" />
          <span>{t("auth.continueWithEmail")}</span>
        </button>
      </form>

      <div className="legal-links">
        <a
          className="legal-link"
          href="https://www.persona-ai.ai/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("auth.termsAndConditions")}
        </a>
        <span className="legal-separator">•</span>
        <a
          className="legal-link"
          href="https://www.persona-ai.ai/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("auth.privacyPolicy")}
        </a>
      </div>
    </div>
  );
};

export default UserLoginView;
